import { Spacer, Typography } from "@aircall/tractor";

import { BetaTag } from "../BetaTag/BetaTag";
import { SectionHeaderProps } from "./SectionHeader.decl";

export function SectionHeader({ children, beta = false }: SectionHeaderProps) {
  return (
    <Spacer space="xxs" flexWrap={{ _: "wrap", xl: "nowrap" }} gap="xxs">
      <Typography variant="bodySemiboldM" color="text-base">
        {children}
      </Typography>
      {beta && <BetaTag />}
    </Spacer>
  );
}
